export interface IconCampaignsProps extends React.SVGProps<SVGSVGElement> {}

export const IconCampaigns = (props: IconCampaignsProps) => {
    return (
        <svg id="icoProducts" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
            <rect id="Rectangle_3763" data-name="Rectangle 3763" width="24" height="24" fill="none" stroke="none" />
            <g id="Group_18" data-name="Group 18" transform="translate(-25 -187)">
                <g
                    id="Rectangle_14"
                    data-name="Rectangle 14"
                    transform="translate(27 200)"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="inherit"
                >
                    <rect width="9" height="9" rx="4.5" stroke="none" />
                    <rect x="0.75" y="0.75" width="7.5" height="7.5" rx="3.75" fill="none" />
                </g>
                <g
                    id="Rectangle_15"
                    data-name="Rectangle 15"
                    transform="translate(38 200)"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="inherit"
                >
                    <rect width="9" height="9" rx="4.5" stroke="none" />
                    <rect x="0.75" y="0.75" width="7.5" height="7.5" rx="3.75" fill="none" />
                </g>
                <g
                    id="Rectangle_16"
                    data-name="Rectangle 16"
                    transform="translate(38 189)"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="inherit"
                >
                    <rect width="9" height="9" rx="4.5" stroke="none" />
                    <rect x="0.75" y="0.75" width="7.5" height="7.5" rx="3.75" fill="none" />
                </g>
                <g
                    id="Rectangle_17"
                    data-name="Rectangle 17"
                    transform="translate(27 189)"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="inherit"
                >
                    <rect width="9" height="9" rx="4.5" stroke="none" />
                    <rect x="0.75" y="0.75" width="7.5" height="7.5" rx="3.75" fill="none" />
                </g>
            </g>
        </svg>
    );
};
